import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {User} from './assign-plan.model';
import {currentPlan} from '../inner/inner-component.model';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NlrAssignPlanService {
    private planSummarySelected = new BehaviorSubject<currentPlan>({} as currentPlan);

    constructor(private http: HttpClient) {}

    findAllUsersByFirmId(url: string): Observable<User[]> {
        console.log(url);
        return this.http.get<User[]>(url);
    }

    updatePlanSummary(newdata: currentPlan) {
        this.planSummarySelected.next(newdata);
    }

    getPlanSummary(): Observable<currentPlan> {
        return this.planSummarySelected;
    }
}
